import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Footer.css";
const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const handleClickHome = () => {
    window.scrollTo(0, 0);
    navigate("/");
  };
  const handleClickAbout = async () => {
    let path = location.pathname;
    if (path !== "/") {
      navigate("/");
      const element = await document.getElementById("about");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      } else {
        scrollToSection("about");
      }
    }
    scrollToSection("about");
  };
  const handleClicklogo = () => {
    window.scrollTo(0, 0);

    navigate("/");
  };
  const handleClickProducts = () => {
    navigate("/product-service");
  };
  const handleClickGallery = () => {
    let path = location.pathname;
    if (path !== "/gallery") {
      navigate("/gallery/project1");
      scrollToSection("gallery");
    } else {
      scrollToSection("gallery");
    }
    navigate("/gallery/project1");
    scrollToSection("gallery");
  };
  const handleClickContact = async () => {
    let path = location.pathname;
    if (path !== "/") {
      navigate("/");
      const element = await document.getElementById("contact");

      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
    scrollToSection("contact");
  };
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div className="footer-container">
      <div className="footer">
        <div className="Header-footer">
          <img
            onClick={() => handleClicklogo()}
            src="footer-logo.png"
            alt="Logo"
            className="logo"
          />
        </div>
        <div className="Contents-footer">
          <div className="details">
            <span className="title-link information">Information</span>
            <ul className="menu-footer">
              <li
                onClick={() => handleClickHome()}
                className="nav-link nav-link-ltr"
              >
                Home
              </li>
              <li
                onClick={() => handleClickAbout()}
                className="nav-link nav-link-ltr"
              >
                About
              </li>
              <li
                onClick={() => handleClickProducts()}
                className="nav-link nav-link-ltr"
              >
                Products
              </li>
              <li
                onClick={() => handleClickGallery()}
                className="nav-link nav-link-ltr"
              >
                Gallery
              </li>
              <li
                onClick={() => handleClickContact()}
                className="nav-link nav-link-ltr"
              >
                Contact
              </li>
            </ul>
          </div>
          <div className="content-footer">
            <div className="details">
              <span className="title-link">Contacts</span>
              <div className="address-block">
                <span className="address-label">Ajman</span>
                <div className="location-details">
                  <img src="Location.svg" alt="location" width="15" height="15" />{" "}
                  <div>
                    AL MANAMA, AJMAN
                    <br /> UAE - PO: 13189
                  </div>
                </div>
              </div>
              <div className="location-details">
                <img src="Phone.svg" alt="location" width="20" height="20" />
                <div>
                  <a href="tel:+971589868440">+971 58 986 8440</a>
                </div>
              </div>
              <div className="address-block address-block-branch">
                <span className="address-label">Sharjah branch</span>
                <div className="location-details">
                  <img src="Location.svg" alt="location" width="15" height="15" />{" "}
                  <div>
                    ARQOUB INDUSTRIAL PLOT NO: 1877
                    <br /> SHARJAH - UAE
                  </div>
                </div>
                <div className="location-details">
                  <img src="Phone.svg" alt="phone" width="20" height="20" />
                  <div>
                    <a href="tel:+97167049974">+971 6 704 9974</a>
                  </div>
                </div>
              </div>
              <div className="location-details">
                <img src="Mail.svg" alt="location" width="20" height="20" />
                <div>
                  <u>
                    <a
                      href="mailto:sales@steelryx.com"
                      rel="noreferrer"
                      target="_blank"
                    >
                      sales@steelryx.com
                    </a>
                  </u>
                </div>
              </div>
            </div>
          </div>
          <div className="social-media">
            <div className="title-link">Social Media</div>
            <br />
            <div className="social-media-icons">
              <div>
                <img src="facebook.svg" alt="facebook" />
              </div>
              <div>
                <img src="X.svg" alt="twitter" />
              </div>
              <div>
                <img src="LinkedIn.svg" alt="linkedin" />
              </div>
              <div>
                <a
                  href="https://instagram.com/steelryx_steel_works_llc?igshid=OGQ5ZDc2ODk2ZA=="
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="instagram.svg" alt="instagram" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyrights">© 2026 All Rights Reserved</div>
    </div>
  );
};

export default Footer;
